import React, { Fragment, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Table } from "antd";
import * as xlsx from "xlsx";

function UploadPreview({ file, onCancel, onOk }) {
  const [preview, setPreview] = useState({});
  useEffect(() => {
    if (file) {
      let reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        const workbook = xlsx.read(e.target.result, {
          type: "buffer",
          sheets: 0,
          sheetRows: "7",
        });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const data = xlsx.utils.sheet_to_json(worksheet);
        let columns;
        if (data.length > 0) {
          const headers = xlsx.utils.sheet_to_json(worksheet, { header: 1 })[0];
          columns = headers.map((item) => ({
            title: item,
            dataIndex: item,
            key: item,
          }));
        }
        setPreview({ data, columns });
      };
    }
  }, [file]);

  return (
    <div id={"UploadPreview"}>
      <h4 className="fileUploadPreviewTitle">
        <FormattedMessage id="FilePreview" defaultMessage="File preview" />
      </h4>
      {preview.data && (
        <React.Fragment>
          <p className="fileUploadPreviewDescription">
            {preview.data.length <= 0 ? (
              <React.Fragment>
                <FormattedMessage
                  id="App.ImportFromFile.Info4"
                  defaultMessage="There is no data in this file."
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <FormattedMessage
                  id="App.ImportFromFile.Info3"
                  defaultMessage="Here's some sample data from your file, click continue to proceed"
                />
              </React.Fragment>
            )}
          </p>
          <Table
            scroll={{ x: "max-content" }}
            bordered
            columns={preview.columns}
            dataSource={preview.data}
            size={"small"}
            pagination={false}
          />
        </React.Fragment>
      )}
      <div className="PreviewFooter">
        <Button onClick={onCancel}>
          <FormattedMessage id="Button.Back" defaultMessage={"Back"} />
        </Button>
        {preview.data && preview.data.length > 0 && (
          <Button className={"upload-button"} type="primary" onClick={onOk}>
            <FormattedMessage
              id="Button.Continue"
              defaultMessage={"Continue"}
            />
          </Button>
        )}
      </div>
    </div>
  );
}

export default UploadPreview;
